import authClient from "../middleware/authClient";

/** @see https://crm-api.inversatechnosoft.com/api/swagger/frontend#/Auth/post_api_v1_auth_player_login */
export const PLAYER_LOGIN_ENDPOINT = "player-login";

/** @see https://crm-api.inversatechnosoft.com/api/swagger/frontend#/Auth/post_api_v1_auth_player_login_mpin */
export const PLAYER_MPIN_LOGIN_ENDPOINT = "player-login/mpin";

/** @see https://crm-api.inversatechnosoft.com/api/swagger/frontend#/Auth/post_api_v1_auth_player_refresh */
export const PLAYER_REFRESH_ENDPOINT = "player-refresh";

export async function playerLogin(payload) {
  const response = await authClient.post(PLAYER_LOGIN_ENDPOINT, payload);
  return response.data;
}

export async function playerMpinLogin(payload) {
  const response = await authClient.post(PLAYER_MPIN_LOGIN_ENDPOINT, payload);
  return response.data;
}

/** Exchanges a refresh token for a new access token. Body: { refreshToken, app_id }. */
export async function playerRefresh(payload) {
  const response = await authClient.post(PLAYER_REFRESH_ENDPOINT, payload);
  return response.data;
}
